import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { CommonService } from '../../common.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { BrowserModule } from '@angular/platform-browser';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
import  jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { NgxDateRangeModule } from 'ngx-daterange';
declare let swal:any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
declare var $:any;
@Component({
  selector: 'app-monthly-calculation-percentage',
  templateUrl: './monthly-calculation-percentage.component.html',
  styleUrls: ['./monthly-calculation-percentage.component.css']
})
export class MonthlyCalculationPercentageComponent implements OnInit {
  loginresponse:any;
  userrole:any;
  percent:any=0;
  farm_userrole:any;
  form_id:any;
  getlistApi:any;
  getlistApi1:any;
  selectallvalue:any;
  loadspeciesValue:any;
  getspeciesvalue:any;
  addUrl:any;
  speciesloaddata:any;
  getlistApiForm:any;
  getData:any=[]; 
  getData1:any=[]; 
  getExportData:any=[]; 
  isLoading = false;
  getfarmsListData:any;
  get_age:any;
  getdiedcunt:any;
  ageUrl :any;
  closing_total:number=0;
  opening_bal:number=0;
  constructor(private router:Router,private commonService: CommonService,private formBuilder: FormBuilder) { }
  
  async ngOnInit(): Promise<void> {
    //$('#reportrange_date').daterangepicker('refresh');
   // var table;
   this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
   this.userrole=this.loginresponse.read_status;
   this.farm_userrole=this.loginresponse.user_farm_id;
   if(this.farm_userrole){
     this.form_id=this.farm_userrole;
   }else{
   this.form_id=null;
   }

    this.getData={opening_count: 0, addition_value: 0, animal_handled: 0, died_count: 0, delete_count: 0,EADR:0,animal_days:0,closing_balance:0,mortality_percentage:0};
        //console.log(this.getData.addition_value);
     this.isLoading =true;
    var table;
      $('.selectpicker').selectpicker('refresh');
      //$('#reportrange_date').daterangepicker('refresh');
      //$('#reportrange_date').daterangepicker('setDate', 0);
      this.getlistApi=(this.form_id!=null)?'/farms/'+this.form_id:"/farms";
      (await this.commonService.getApi(this.getlistApi)).subscribe(
        async(res) => {
           $(function(){
           table = $("#myTable").DataTable();
           })
           this.getfarmsListData = (this.form_id!=null)?[res.data]:res.data;
           this.getfarmsListData.unshift({tnfr_id:null,tnfr_name:"Select Farm Name"});
    });
    

    setTimeout(function () {
     $('#reportrange_date').daterangepicker('refresh');
      $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
      //$('#reportrange_date').daterangepicker('refresh');
   }, 1500);
   $('#farmname').change(async ()=> {
    $("#speciesid").find('option').remove().end();
    //console.log(  $('#farmname').val())
      this.selectallvalue= $('#farmname').val();
      var farmvalue="";
  farmvalue = this.selectallvalue.toString();
  this.loadspeciesValue = {
  "farms_id":farmvalue
  };
  //console.log(this.loadspeciesValue.farm_id)
  if(farmvalue!="null"){
        //species load in select dropdown based on farm select api call
        this.addUrl = "/species/farms";
        (await this.commonService.postApi(this.addUrl,this.loadspeciesValue)).subscribe(
          res => {
            this.speciesloaddata=res.data;
            this.speciesloaddata.unshift({id:null,name:"Select Species Name"});
            //console.log( this.speciesloaddata)
            
          })

        }else{
          $('#Speciesname').val('null');
          this.speciesloaddata=[{id:null,name:"Select Species Name"}];
          $('#BreedName').val('null');
          this.getspeciesvalue=[{id:null,name:"Select Breed Name"}];
         $('#age').val('null');
         this.get_age=[{tnag_id:null,tnag_name:"Select Age",tnag_time_range:'0'}];
        }
          setTimeout(function () {
            $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
         }, 1500);
    });
      
  $(document).on('change', '#farmname', function() {
    $('.myFakeClass').dropdown('toggle');
  });
  $(document).on('change', '#Speciesname', function() {
    $('.myFakeClass1').dropdown('toggle');
  });
  $(document).on('change', '#BreedName', function() {
    $('.myFakeClass2').dropdown('toggle');
  });
  $(document).on('change', '#age', function() {
    $('.myFakeClass3').dropdown('toggle');
  });
  }


  async breedselectbyspecies(event){
    //console.log(event.target.value);
    if(event.target.value!='null'){
    this.addUrl = "/breeds/species/"+event.target.value;
    (await this.commonService.getApi(this.addUrl)).subscribe(
      res => {
           this.getspeciesvalue=res.data;
           this.getspeciesvalue.unshift({id:null,name:"Select Breed Name"});
          //console.log(this.getspeciesvalue);
      });
      this.ageUrl="/species/age_group/all_category/?species_id="+event.target.value;
      (await this.commonService.getApi(this.ageUrl)).subscribe(
        res => {
             this.get_age=res.data;
             this.get_age.unshift({tnag_id:null,tnag_name:"Select Age",tnag_time_range:'0'});
            //console.log(this.get_age);
        });

      }else{
        $('#BreedName').val('null');
        this.getspeciesvalue=[{id:null,name:"Select Breed Name"}];
       $('#age').val('null');
       this.get_age=[{tnag_id:null,tnag_name:"Select Age",tnag_time_range:'0'}];
      }
      setTimeout(function () {
        $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
     }, 1000);
  }

  async get_datas(){
    
    var from_date = $("input[name='daterangepicker_start']" ).val();
    var to_date = $("input[name='daterangepicker_end']" ).val();
   // var farm_id=(this.form_id!=null)?this.form_id:$('#farmname').val();
   var farm_id=(this.form_id!=null)?this.form_id:$('#farmname').val();
    var species_id=$('#Speciesname').val();
var breed_id=$('#BreedName').val();
var age=$('#age').val();
    this.getlistApi="/reports/monthly_percentage/?from_date="+from_date+"&to_date="+to_date+"&farm_id="+farm_id+"&species_id="+species_id+"&breed_id="+breed_id+"&age="+age;
     (await this.commonService.getApi(this.getlistApi)).subscribe(
      (res) => {
      
          let get_date=res.data[0];
          this.getExportData=get_date;
          this.getData = get_date;
          this.getdiedcunt=res.data[0].died_count;
         // console.log(this.getdiedcunt);
         // console.log(this.getData.addition_value);
          setTimeout((res)=>{ 
           this.isLoading =false;
     }, 500)
     this.get_animal_days();

         }) ;

  }

  arrayColumn(array, columnName) {
    return array.map(function(value,index) {
        return value[columnName];
    })
  }
  
  async get_animal_days(){

    var getDaysArray = function(start, end) {
      for(var arr=[],dt=new Date(start); dt<=end; dt.setDate(dt.getDate()+1)){
      var date=new Date(dt);
        var d = date.getDate();
      var m = date.getMonth() + 1;
      var y = date.getFullYear();
  
          arr.push(y+'-' + (m <= 9 ? '0' + m : m)+ '-'+(d <= 9 ? '0' + d : d));
      }
      return arr;
  };


    var from_date = $("input[name='daterangepicker_start']" ).val();
    var to_date = $("input[name='daterangepicker_end']" ).val();
    var farm_id=($('#farmname').val()==null)?this.form_id:$('#farmname').val();
    var species_id=$('#Speciesname').val();
var breed_id=$('#BreedName').val();
var age=$('#age').val();
this.getlistApi1="/reports/monthly_report/?from_date="+from_date+"&to_date="+to_date+"&farm_id="+farm_id+"&species_id="+species_id+"&breed_id="+breed_id+"&age="+age;
this.closing_total=0;
 
var daylist = getDaysArray(new Date(from_date),new Date(to_date));
    (await this.commonService.getApi(this.getlistApi1)).subscribe(
      (res) => {  
        this.opening_bal= (res.data!=undefined)?res.data[0].opening_count:0;       
        let x=0; 
        let j=0; 
        let y=0;
        let closing_tot=0;
        
        //console.log(res.data);
        this.getData1=[];
        for(x=0;x<daylist.length;x++){
          for(j=0;j<res.data.length;j++){
            var arr=this.arrayColumn(this.getData1, 'date');
            if(arr.includes(daylist[x])==false){
              if(res.data[j].date==daylist[x]){
                
                y=j+1;
                this.getData1.push(res.data[j]);
                closing_tot=res.data[j].daily_closing_balance+closing_tot;
                //console.log('true',closing_tot);
              }else{
                var arr1=this.arrayColumn(this.getData1, 'date');
               
                if(arr1.includes(res.data[j].date)==false ){
                  //console.log("first",y);
                  closing_tot=((y==0)?this.opening_bal:res.data[y-1].daily_closing_balance)+closing_tot;
                  //console.log('true_else',closing_tot);
                  this.getData1.push({
                    "date": daylist[x],
                    "opening_count": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance,
                    "additon_count": 0,
                    "total_count": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance,
                    "death_count": 0,
                    "deletion_count": 0,
                    "daily_closing_balance": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance
                  });
                  
                }else{
                  if(y==res.data.length){
                    closing_tot=(y==0)?this.opening_bal:res.data[y-1].daily_closing_balance+closing_tot;
                    //console.log("first2",closing_tot);
                    this.getData1.push({
                      "date": daylist[x],
                      "opening_count": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance,
                      "additon_count": 0,
                      "total_count": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance,
                      "death_count": 0,
                      "deletion_count": 0,
                      "daily_closing_balance": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance
                    });
                    
                  }
                }
      
              }
              
            }
           // console.log(closing_tot);
          }
        }
        this.closing_total=closing_tot;
        //$("#animal_days").html(closing_total);

        this.percent= (this.getdiedcunt/this.closing_total*1000).toFixed(2);
        
         }) ;
      
  }

  public exportdata()
{
//var data = document.getElementById('contentToConvert');
let data = document.getElementById('contentToConvert');  
html2canvas(data).then(canvas => {
  const contentDataURL = canvas.toDataURL('image/png')  
  let pdf = new jspdf('l', 'cm', 'a4'); //Generates PDF in landscape mode
  // let pdf = new jspdf('p', 'cm', 'a4'); Generates PDF in portrait mode
  pdf.addImage(contentDataURL, 'PNG', 0, 0, 29.7, 21.0);  
  pdf.save('Monthly_calculaton_percentage.pdf');   
}); 
}


date_format(dateObject) {
  var d = new Date(dateObject);
  let day = d.getDate();
  var month = d.getMonth() + 1;
  var year = d.getFullYear();
  if (day < 10) {
      var day1 = "0" + day;
  }
  if (month < 10) {
     var month1 = "0" + month;
  }
  var date = year + "-" + month1 + "-" + day1;

  return date;
};

  exportdata1(){
    this.exportAsExcelFile(this.getExportData, 'data');
  }
  public exportAsExcelFile(json: any[], excelFileName: string): void {
  
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    console.log('worksheet',worksheet);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

}
